export const languages = ['en', 'es', 'fr'];
